export default __webpack_public_path__ + "static/media/antenatalCareImg.ee99ce28.png";